import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {DownloadPdf} from "../reducers/files";



class Getreport extends Component {
  
    constructor(props) {
        super(props);
        this.state = {
          day:'',
          moht:'',
          isdemopdf:false,
          idpdf:'',
          correctpass:'haslo',
          password:'',
          isdownloandforclient:true,
          correctpassbool:false
        }
        
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeday = this.handleChangeday.bind(this);
        this.handleChangemont = this.handleChangemont.bind(this);
        this.handleChangedemo= this.handleChangedemo.bind(this);
        this.changeid= this.changeid.bind(this);
      }
      
    

      
      handleChange(event) {
        this.setState({password: event.target.value});
      }

      handleChangeday(event) {
         
            this.setState({day: event.target.value});
          }

     handleChangemont(event) {
         
            this.setState({moht: event.target.value});
          }
    handleChangedemo() {
            const isdemopdf=this.state.isdemopdf;
            this.setState({isdemopdf:!isdemopdf});
           // alert(isdemopdf);
            
          }
        
          changeid(event) {
         
            this.setState({idpdf: event.target.value});
          }
    
 
     
    
      checkpassword = () => {
         const password=this.state.password;
         const correctpass=this.state.correctpass;
         console.log(correctpass);
         console.log(password);
         if(password === correctpass){
            this.setState({isdownloandforclient:true});
            this.setState({correctpassbool:true});
         }else{
            alert('Podano wlasciwe hasło');
         }
        
      }
    
     
  render () {
    const {DownloadPdf} = this.props;
  const{correctpassbool,day,moht,isdemopdf,idpdf,isdownloandforclient}=this.state;
    return [
      !correctpassbool ? [
        <div className="default-block container" key={1}>
            <h1 style={{marginTop:'50px'}} >By pobrać Archiwalny raport wpisz hasło: </h1>
            <label style={{marginRight : "10px", fontFamily: 'Arial',fontSize :'21px'}}>
             Hasło:
                 <input style={{marginLeft : "10px"}} value={this.state.password} onChange={this.handleChange} />
            </label>
            
            
            <button  className="wp-block-button__link download-pdf-button"
                 style={{borderRadius: 5, backgroundColor: '#f54d4d', fontFamily: 'Arial',fontSize :'15px',padding: '5px'}}onClick={this.checkpassword}>Zaloguj</button>
        </div>] : [
            <div className="flexcontainer-100" key={2}>
                 <h1 style={{marginTop:'50px'}} >By pobrac Archiwalny raport uzupełnij dane: </h1>
                <div className="flexcontainer-row">
                <label>Dzień:
                <select className="paddingselect" value={this.state.day} onChange={this.handleChangeday}>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                        <option value="13">13</option>
                        <option value="14">14</option>
                        <option value="15">15</option>
                        <option value="16">16</option>
                        <option value="17">17</option>
                        <option value="18">18</option>
                        <option value="19">19</option>
                        <option value="20">20</option>
                        <option value="21">21</option>
                        <option value="22">22</option>
                        <option value="23">23</option>
                        <option value="24">24</option>
                        <option value="25">25</option>
                        <option value="26">26</option>
                        <option value="27">27</option>
                        <option value="28">28</option>
                        <option value="29">29</option>
                        <option value="30">30</option>
                        <option value="31">31</option>
                        
                        </select> 

                </label>
                <label>Miesiąc:
                <select className="paddingselect" value={this.state.moht} onChange={this.handleChangemont}>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                        
                        </select> 

                </label>
                </div>
            <label>
                Ramort z porownania demo :
                <input type="checkbox"  onChange={this.handleChangedemo}/>
            </label><br></br>
            
            <label>
                Idraportu: 
                <input value={idpdf} id="idreporttextfield" type="textfield" onChange={this.changeid}/>
                
                </label><br></br>
               
            <button
                 className="wp-block-button__link download-pdf-button"
                 style={{borderRadius: 5, backgroundColor: '#f54d4d', fontFamily: 'Arial'}}
                 //dopiac disable
                 onClick={()=>{DownloadPdf({day,moht,isdemopdf,idpdf,isdownloandforclient});}}>Pobierz raport z dnia:  {day}.{moht}</button>
            
            </div>
        ]
     
    ]
  }
}

Getreport.propTypes = {
  
   DownloadPdf:PropTypes.func,
   
   
};

Getreport.defaultProps = {
   
    DownloadPdf: () => {},

    
  };

export default connect (({day,moht,isdemopdf}) => ({
   isdemopdf,
    moht,
    day      
        
      }),{DownloadPdf})(Getreport) ;
//export default Getreport ;

  

  
 
  
  